<template>
  <div id="app">
    <v-app>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        dark
        :color="$route.path.split('/')[1] == '8dio' ? '#f5f5f5' : 'primary'"
        v-if="privateRoute()"
      >
        <svg
          width="171"
          height="22"
          viewBox="0 0 171 22"
          fill=""
          xmlns="http://www.w3.org/2000/svg"
          v-if="$route.path.split('/')[1] == 'soundpaint'"
        >
          <path
            d="M39.9167 14.2C39.9167 10.84 37.2767 9.4 33.9167 8.92C30.5567 8.44 29.5967 7.96 29.5967 6.52C29.5967 5.56 30.3167 4.84 32.4767 4.84C35.1167 4.84 35.8367 5.56 35.8367 7L36.0767 7.24H38.9567L39.1967 7C39.1967 4.12 37.2767 1.96 32.7167 1.96C28.1567 1.96 26.2367 4.12 26.2367 6.52C26.2367 9.88 28.8767 11.08 32.2367 11.56C35.5967 12.04 36.5567 12.52 36.5567 14.2C36.5567 15.64 35.3567 16.36 33.1967 16.36C30.3167 16.36 29.3567 15.4 29.3567 13.72L29.1167 13.48H26.2367L25.9967 13.72C25.9967 16.84 28.1567 19.24 32.9567 19.24C37.9967 19.24 39.9167 16.84 39.9167 14.2ZM53.6005 10.6C53.6005 13.96 51.9205 16.36 48.8005 16.36C45.6805 16.36 44.0005 13.96 44.0005 10.6C44.0005 7.24 45.6805 4.84 48.8005 4.84C51.9205 4.84 53.6005 7.24 53.6005 10.6ZM56.9605 10.6C56.9605 5.56 53.8405 1.96 48.8005 1.96C43.7605 1.96 40.6405 5.56 40.6405 10.6C40.6405 15.64 43.7605 19.24 48.8005 19.24C53.8405 19.24 56.9605 15.64 56.9605 10.6ZM72.0748 2.44L71.8348 2.2H68.9548L68.7148 2.44V12.52C68.7148 14.92 67.7548 16.36 65.3548 16.36C62.9548 16.36 61.9948 14.92 61.9948 12.52V2.44L61.7548 2.2H58.8748L58.6348 2.44V12.52C58.6348 16.84 61.0348 19.24 65.3548 19.24C69.6748 19.24 72.0748 16.84 72.0748 12.52V2.44ZM74.7083 2.44V18.76L74.9483 19H77.8283L78.0683 18.76V7.72H78.3083L84.7883 18.76L85.2683 19H88.6283L88.8683 18.76V2.44L88.6283 2.2H85.7483L85.5083 2.44V13.48H85.2683L78.7883 2.44L78.3083 2.2H74.9483L74.7083 2.44ZM105.188 10.6C105.188 5.32 103.028 2.2 97.0283 2.2H91.7483L91.5083 2.44V18.76L91.7483 19H97.0283C103.028 19 105.188 15.88 105.188 10.6ZM101.828 10.6C101.828 14.44 100.628 16.12 97.2683 16.12H95.1083L94.8683 15.88V5.32L95.1083 5.08H97.2683C100.628 5.08 101.828 6.76 101.828 10.6ZM120.799 7.24C120.799 3.88 118.399 2.2 115.039 2.2H107.119L106.879 2.44V18.76L107.119 19H109.999L110.239 18.76V12.52L110.479 12.28H115.039C118.399 12.28 120.799 10.6 120.799 7.24ZM117.439 7.24C117.439 8.92 116.479 9.4 115.039 9.4H110.479L110.239 9.16V5.32L110.479 5.08H115.039C116.479 5.08 117.439 5.56 117.439 7.24ZM133.996 18.76V16.36L128.476 2.44L128.236 2.2H125.116L124.876 2.44L119.356 16.36V18.76L119.596 19H121.756L121.996 18.76L123.196 15.64L123.676 15.4H129.676L130.156 15.64L131.356 18.76L131.596 19H133.756L133.996 18.76ZM128.956 12.28L128.716 12.52H124.636L124.396 12.28L126.556 6.52H126.796L128.956 12.28ZM138.565 18.76V2.44L138.325 2.2H135.445L135.205 2.44V18.76L135.445 19H138.325L138.565 18.76ZM141.2 2.44V18.76L141.44 19H144.32L144.56 18.76V7.72H144.8L151.28 18.76L151.76 19H155.12L155.36 18.76V2.44L155.12 2.2H152.24L152 2.44V13.48H151.76L145.28 2.44L144.8 2.2H141.44L141.2 2.44ZM170.48 4.84V2.44L170.24 2.2H156.8L156.56 2.44V4.84L156.8 5.08H161.6L161.84 5.32V18.76L162.08 19H164.96L165.2 18.76V5.32L165.44 5.08H170.24L170.48 4.84Z"
            fill="#f1ece7"
          ></path>
          <path
            d="M0 0.0673759V21.5333H4.21436C4.21436 21.5333 4.28174 17.5164 9.54851 15.2775C14.8153 13.0386 17.7798 11.3266 17.7798 6.58599C17.7798 1.84542 13.8289 0.658599 13.8289 0.658599C13.8289 0.658599 12.3581 0 7.77046 0C1.97546 0 0 0.0673759 0 0.0673759Z"
            fill="#f1ece7"
          ></path>
        </svg>
        <svg
          width="140"
          height="24.48"
          viewBox="0 0 164 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-else
          style="opacity: 0.9"
        >
          <path
            d="M43.0108 13.0517C43.0879 12.9391 43.154 12.8424 43.2213 12.7456C43.3033 12.6281 43.3902 12.513 43.471 12.393C44.7217 10.5075 45.057 8.46766 44.4708 6.29928C43.493 2.67757 40.0199 0.766317 37.0645 0.772438C27.279 0.790804 17.4936 0.77856 7.70939 0.784682C7.27372 0.784682 6.83315 0.821414 6.40483 0.896101C0.941826 1.83765 -1.88758 7.82731 1.40564 12.4665C1.51456 12.6195 1.62225 12.775 1.73851 12.9415C1.5733 13.1803 1.42522 13.3946 1.27714 13.6101C-1.14841 17.151 -0.0567865 22.1697 4.04536 24.3185C5.20796 24.927 6.44399 25.2282 7.75712 25.2343C9.16937 25.2417 10.5804 25.2368 11.9927 25.2368C20.2202 25.2368 28.4465 25.2404 36.6741 25.2306C37.3031 25.2294 37.9492 25.2061 38.5611 25.0751C44.0658 23.9022 46.4766 18.0092 43.3817 13.5929C43.2593 13.4166 43.1393 13.2403 43.0108 13.0517ZM7.29819 6.19032C7.51603 6.17073 7.73631 6.1744 7.95415 6.1744C17.5646 6.1744 27.175 6.1744 36.7867 6.1744C36.9812 6.1744 37.1758 6.17072 37.3704 6.18542C38.3115 6.25031 39.1204 6.92372 39.3493 7.82486C39.6258 8.91088 38.9662 9.99201 37.8538 10.2271C37.4769 10.3042 37.0804 10.3116 36.6924 10.3116C31.9245 10.3177 27.1554 10.3152 22.3863 10.3152C17.6417 10.3152 12.897 10.3165 8.1524 10.3128C7.81341 10.3128 7.4683 10.3091 7.13421 10.2577C6.05238 10.0912 5.27282 9.1729 5.32789 8.16157C5.38296 7.15145 6.24818 6.28092 7.29819 6.19032ZM37.4854 19.8164C37.2187 19.8372 36.9494 19.8323 36.6826 19.8323H8.14016C7.89663 19.8323 7.65309 19.8385 7.41078 19.8262C6.47948 19.776 5.63751 19.0953 5.40621 18.2125C5.12474 17.1387 5.70482 16.12 6.79032 15.8017C6.99714 15.7392 7.21742 15.7135 7.43403 15.6915C7.60292 15.6719 7.77425 15.6854 7.94436 15.6854H36.7059C36.9249 15.6854 37.1452 15.6768 37.3631 15.6939C38.2919 15.7686 39.0776 16.371 39.3236 17.1705C39.7715 18.6239 38.5073 19.7393 37.4854 19.8164ZM94.798 4.05867C92.8008 1.90744 90.3813 0.728361 87.3365 0.761419C82.0069 0.820189 76.6761 0.777336 71.3453 0.777336C65.8688 0.777336 60.3923 0.777336 54.9159 0.777336C54.6968 0.777336 54.4778 0.772438 54.2587 0.77856C52.8146 0.821414 51.6826 1.90132 51.5982 3.3167C51.5872 3.5077 51.5921 3.6987 51.5921 3.88848C51.5921 9.97242 51.5921 16.0564 51.5921 22.1391C51.5921 22.3546 51.5859 22.5701 51.6043 22.7831C51.7071 23.9414 52.5527 24.9025 53.7141 25.1413C54.0898 25.2184 54.4863 25.2306 54.8731 25.2306C65.777 25.2355 76.681 25.2343 87.585 25.2343C87.7551 25.2343 87.9252 25.2392 88.0965 25.2331C89.6838 25.1768 91.167 24.7788 92.5071 23.923C93.6819 23.1725 94.705 22.2578 95.5102 21.1339C97.9505 17.7325 98.7643 13.9884 97.8465 9.921C97.3508 7.71956 96.3559 5.7373 94.798 4.05867ZM92.6245 15.2691C92.0469 17.7987 89.9652 19.6413 87.2117 19.8115C86.8483 19.8348 86.4823 19.8311 86.1164 19.8311C76.7446 19.8323 67.3741 19.8323 58.0011 19.8311C57.7367 19.8311 57.4724 19.8189 57.1334 19.8103V6.25276C57.2864 6.2246 57.4222 6.19031 57.5593 6.17807C57.7037 6.1646 57.8505 6.17317 57.9962 6.17317C67.4169 6.17317 76.8376 6.17195 86.2572 6.17685C86.8164 6.17685 87.3818 6.19154 87.9301 6.27969C90.21 6.64456 92.1118 8.36481 92.6392 10.7964C92.9623 12.2951 92.9648 13.779 92.6245 15.2691ZM163.176 8.41256C162.335 6.06176 160.985 4.0599 158.948 2.53432C157.364 1.3479 155.585 0.767541 153.588 0.773663C149.329 0.788355 145.069 0.777336 140.809 0.77856C136.55 0.77856 132.29 0.781009 128.031 0.774887C127.296 0.773663 126.575 0.845901 125.86 1.00017C124.449 1.30504 123.221 1.96988 122.126 2.8698C119.244 5.2402 117.821 8.34645 117.477 11.9596C117.285 13.9835 117.616 15.9572 118.342 17.8599C119.263 20.2658 120.714 22.2799 122.889 23.7602C124.333 24.7433 125.941 25.2294 127.689 25.2306C136.281 25.2404 144.873 25.2392 153.465 25.227C154.094 25.2257 154.729 25.1474 155.349 25.0384C156.848 24.7752 158.143 24.0785 159.299 23.1308C162.076 20.8535 163.493 17.8684 163.914 14.3973C164.159 12.3514 163.871 10.352 163.176 8.41256ZM158.34 15.5115C157.697 17.9639 155.554 19.6732 152.955 19.814C152.639 19.8311 152.321 19.8311 152.007 19.8311C144.463 19.8323 136.921 19.8348 129.379 19.8274C128.822 19.8274 128.255 19.8042 127.708 19.7111C125.404 19.3157 123.907 17.9578 123.191 15.8201C122.567 13.9602 122.599 12.0563 123.181 10.183C123.862 7.99872 125.885 6.28214 128.425 6.20011C128.814 6.18787 129.204 6.1744 129.592 6.1744C133.291 6.17195 136.989 6.17317 140.686 6.17317C144.458 6.17317 148.23 6.16705 152.002 6.1793C152.631 6.18174 153.276 6.19889 153.886 6.32867C156.219 6.82332 157.695 8.25584 158.331 10.4879C158.805 12.1506 158.778 13.8378 158.34 15.5115ZM107.986 0.776112C106.559 0.695303 105.302 1.69929 105.101 3.0755C105.066 3.30935 105.07 3.55055 105.07 3.78931C105.068 6.86617 105.069 9.94304 105.069 13.0211C105.069 16.0502 105.069 19.0806 105.07 22.1097C105.07 22.3252 105.061 22.5407 105.08 22.7525C105.195 24.1005 106.282 25.1523 107.661 25.2257C109.256 25.3114 110.336 24.1666 110.516 23.0659C110.563 22.7855 110.578 22.4966 110.578 22.2125C110.581 16.0821 110.58 9.95038 110.58 3.82114C110.58 3.63014 110.587 3.43791 110.569 3.24936C110.447 1.89519 109.333 0.852023 107.986 0.776112Z"
            fill="#1B1B1B"
          ></path>
        </svg>
        &nbsp;&nbsp;<span
          style="
            opacity: 0.4;
            font-size: 12px;
            margin-bottom: -8px;
            color: black;
          "
          >v1.0.2</span
        >
        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-avatar :size="36" class="secondary lighten-1">
                <v-icon color="primary">person</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item>
              <v-list-item-title
                ><v-btn color="primary" text to="/profile"
                  >profile</v-btn
                ></v-list-item-title
              >
            </v-list-item> -->
            <v-list-item>
              <v-list-item-title
                ><v-btn color="primary" text @click="signout"
                  >signout</v-btn
                ></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        v-if="privateRoute() && user"
        width="160"
        :color="$route.path.split('/')[1] == '8dio' ? '#f5f5f5' : 'secondary'"
      >
        <v-list dense>
          <template v-for="(item, i) in navItems">
            <v-layout v-if="item.heading" :key="i" align-center>
              <v-flex xs12>
                <v-subheader v-if="item.heading">{{
                  item.heading
                }}</v-subheader>
              </v-flex>
            </v-layout>
            <v-divider
              v-else-if="item.divider"
              :key="i"
              dark
              class="my-2 mt-0"
            ></v-divider>
            <v-list-item v-else :key="i" :to="item.link" :target="item.target">
              <v-list-item-action class="mr-3">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="grey--text">
                  {{ item.text
                  }}<span v-if="item.new"
                    ><v-chip small class="ml-3" color="green" dark
                      >new</v-chip
                    ></span
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-main
        class="content"
        :style="{
          background:
            $route.path.split('/')[1] == '8dio' ? '#f5f5f5' : '#f1ece7',
        }"
      >
        <div class="pa-2">
          <router-view />
        </div>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "@/main";
export default {
  name: "App",
  data: () => ({
    dialog: false,
    drawer: null,
    navItems: [
      { heading: "Soundpaint" },
      {
        icon: "local_offer",
        text: "Products",
        link: "/soundpaint/products",
      },
      {
        icon: "queue_music",
        text: "Instruments",
        link: "/soundpaint/instruments",
      },
      {
        icon: "person",
        text: "Customers",
        link: "/soundpaint/customers",
      },
      {
        icon: "music_note",
        text: "Engine",
        link: "/soundpaint/engine",
      },
      {
        icon: "extension",
        text: "App Features",
        link: "/soundpaint/features",
      },
      { divider: true },
      { heading: "8DIO" },
      {
        icon: "local_offer",
        text: "Products",
        link: "/8dio/products",
      },
      {
        icon: "queue_music",
        text: "Instruments",
        link: "/8dio/instruments",
      },
      {
        icon: "person",
        text: "Customers",
        link: "/8dio/customers",
      },
    ],
  }),
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.$store.state;
  },
  methods: {
    privateRoute() {
      return this.$route.meta.requiresAuth;
    },
    signout: async function () {
      try {
        await fb.auth.signOut();
        this.$router.push("/login");
      } catch (error) {
        alert(error);
      }
    },
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      } else {
        return;
      }
    },
  },
};
</script>

<style>
.content {
  background: #f1ece7;
}
</style>
